<template>
  <FilterButton title="Benchmarks" @close="benchmarkSelectorChange" :active="true" data-test="benchmark-filter">
    <template #menu="{ close }">
      <div class="menu">
        <div class="fields">
          <div class="field">
            <h5>Available Benchmarks</h5>
            <template v-for="benchmark in benchmarkOptions">
              <label v-if="hasPermission(benchmark)" :key="benchmark.link" :for="benchmark.link">
                <input :id="benchmark.link"
                       type="radio" name="benchmark"
                       :value="benchmark.link" v-model="newSelected"
                />
                <span>{{ benchmark.name }}</span>
              </label>
            </template>
          </div>
        </div>
        <div class="buttons">
          <v-btn size="small" variant="flat" color="primary" @click="close" data-test="account-benchmark-view-options-apply">Done</v-btn>
        </div>
      </div>
    </template>
  </FilterButton>
</template>

<script lang="ts">
import FilterButton from '@/components/FilterButton.vue';
import { BenchmarkOption } from '@/views/account/benchmarking/Benchmarking';
import Store from '@/store';
import { PropType } from 'vue';

export default {
  name: 'BenchmarkSelector',
  props: {
    benchmarkOptions: { required: true, type: Array as PropType<Array<BenchmarkOption>> },
    selected: { required: true, type: String as PropType<string> }
  },
  data: function() {
    return { newSelected: this.selected as string | undefined };
  },
  components: { FilterButton },
  methods: {
    benchmarkSelectorChange() {
      this.$emit('change', this.newSelected);
    },
    hasPermission(opt: BenchmarkOption): boolean {
      return opt.requirements.every(check => check(Store.state.user))
    }
  }
};
</script>

<style scoped>
.menu {
  padding: 1rem 0 0 0;
  min-width: 300px;
}

.menu > h4 {
  padding: 0 1rem;
}

.menu > .fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  padding: 0 1rem 1rem;
}

.menu > .fields > .field > h5 {
  font-size: 0.8rem;
  letter-spacing: 0.02em;
  margin: 1rem 0 0.5rem;
  text-transform: uppercase;
  font-weight: 500;
}

.menu > .fields > .field > label {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
  align-items: center;
  align-content: center;
  padding: 0.2rem 0;
  cursor: pointer;
  user-select: none;
}

.menu > .buttons {
  padding: 1rem;
  border-top: 1px solid var(--v-border-base);
  background: var(--v-gray-lighten5);
  display: flex;
  justify-content: flex-end;
}
</style>
